import { CoreTooltip } from '@featuring-corp/components';
import { IconInformationFilled } from '@featuring-corp/icons';
import { vars } from '@styles/vanilla-extract/theme.css';
import React from 'react';

import { coloredSectionClass, iconClass } from './style.css';
import ColoredChartText, {
	ColoredTextProps,
} from '../chart/colored-chart-text/ColoredChartText';

export interface ColoredSectionProps extends ColoredTextProps {
	tooltip?: string;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const ColoredSection = ({
	children,
	tooltip,
	isLoading,
	isError,
	lackOfPermission,
}: ColoredSectionProps) => {
	return (
		<div className={coloredSectionClass}>
			<ColoredChartText
				isLoading={isLoading}
				isError={isError}
				lackOfPermission={lackOfPermission}
			>
				{children}
				{tooltip && (
					<>
						{' '}
						<div className={iconClass}>
							<CoreTooltip text={tooltip} zIndex={10000}>
								<IconInformationFilled
									size={14}
									fill={vars.semantic.color.icon.tertiary}
								/>
							</CoreTooltip>
						</div>
					</>
				)}
			</ColoredChartText>
		</div>
	);
};

export default ColoredSection;
